import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BlogPost } from '@blog-models/blog-posts.model';
import { Observable, Subject } from 'rxjs';
import { BlogService } from '../blog/blog.service';

@Injectable({
    providedIn: 'root',
})
export class TagService {
    private filteredPostsSubject = new Subject<BlogPost[]>();
    private selectedTagsSubject = new Subject<string[]>();

    private selectedTags: string[] = [];
    private filteredPosts: BlogPost[] = [];

    public constructor(
        private blogService: BlogService,
        private router: Router
    ) {}

    public getTags(): Observable<string[]> {
        return this.selectedTagsSubject.asObservable();
    }

    public getFilteredPosts(): Observable<BlogPost[]> {
        return this.filteredPostsSubject.asObservable();
    }

    public addTag(tag: string): void {
        // prevent tags from being multiple times added
        if (this.selectedTags.indexOf(tag) === -1) {
            this.selectedTags.push(tag);
            this.blogService.getPostsByTags(this.selectedTags).subscribe((response) => {
                this.filteredPosts = response;
                this.updatePosts();
                this.updateTags();
            });
        }
    }

    public removeTag(tag: string): void {
        const index = this.selectedTags.indexOf(tag);
        if (index > -1) {
            this.selectedTags.splice(index, 1);
            this.updateTags();
        }
        this.removePostsWithUnsetTags();
    }

    public clearAllTags(): void {
        this.selectedTags = [];
        this.filteredPosts = [];
        this.updateTags();
    }

    public clearBrowserUrl(): void {
        this.router.navigate([], {
            queryParams: {
                tags: null,
            },
            queryParamsHandling: 'merge',
        });
    }

    private removePostsWithUnsetTags() {
        this.filteredPosts = this.filteredPosts.filter((post) => {
            if (post.tags.find((tag) => this.selectedTags.find((filteredTag) => tag === filteredTag))) {
                return true;
            }

            return false;
        });
        this.updatePosts();
    }

    private updatePosts() {
        this.filteredPostsSubject.next(this.filteredPosts);
    }

    private updateTags(): void {
        this.selectedTagsSubject.next(this.selectedTags);
    }
}
